export enum ClassifierCode {
  PARTNERA_VEIDS = 'PARTNERA_VEIDS',
  PAKALPOJUMU_GRUPA = 'PAKALPOJUMU_GRUPA',
  PARTNERA_PERSONAS_LOMA = 'PARTNERA_PERSONAS_LOMA',
  MĒRVIENĪBA = 'MĒRVIENĪBA',
  BIRKA = 'BIRKA',
}
